module.exports = __webpack_public_path__ + "img/googlePlayStoreButton.2c975a1d.svg";